<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [modalMixin],

  props: {
    links: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <modal
    :id="id"
    :should-display-header="false"
    :should-wrap-content="true"
    :container-classes="['modal__container--center', 'bg-black', 'text-white']"
    :header-classes="['bg-black']"
    :content-classes="['bg-black sgphx pt-0 cstm-personal-assistant-content']"
    :classes="['pt-0 text-white']"
    close-button-outside
  >
    <template #content>
      <div class="section section--sm bg-black">
        <h3 class="h4">{{ $t('PersonalAssistant.modalTitle') }}</h3>
        <p>{{ $t('PersonalAssistant.modalText') }}</p>
      </div>
      <div class="sgphx-actions sgphx-actions--full">
        <a
          v-for="link in links"
          :key="link.id"
          class="sgphx-btn sgphx-btn--primary sgphx-btn--icon"
          :href="link.href"
          :data-tracking="link.trackingData"
        >
          <span class="sgphx-btn__icon sgphx-btn__icon--start">
            <phx-icon :icon="link.icon" />
          </span>
          <span class="sgphx-btn__text">
            <span>
              {{ link.text }}
            </span>
          </span>
        </a>
      </div>
    </template>
  </modal>
</template>

<style>
.cstm-personal-assistant-content {
  width: 100%;
}
</style>
